/**
 * Extracts the raw `rootPage` macro parameter value, supporting all known
 * legacy parameter aliases (`rootPage`, `rootpage`, `'0'`).
 *
 * Returns `undefined` when no `rootPage` parameter is set.
 */
export const getRootPageParam = (
	macroParams?: Record<string, { value?: string } | undefined>,
): string | undefined => {
	if (!macroParams) {
		return undefined;
	}
	return macroParams.rootPage?.value ?? macroParams.rootpage?.value ?? macroParams['0']?.value;
};

/**
 * Parses the `rootPage` macro parameter string into `{ spaceKey, title, hasExplicitSpace }`.
 *
 * Supported shapes:
 * - `"Some Page"`           -> { spaceKey: defaultSpaceKey, title: "Some Page", hasExplicitSpace: false }
 * - `"MYSPACE:Some Page"`   -> { spaceKey: "MYSPACE",       title: "Some Page", hasExplicitSpace: true }
 * - `":Some Page"`          -> { spaceKey: defaultSpaceKey, title: "Some Page", hasExplicitSpace: false }
 * - `"MYSPACE:"`            -> { spaceKey: "MYSPACE",       title: "",          hasExplicitSpace: true }
 */
export const parseRootPageString = (
	rootPageString: string,
	defaultSpaceKey: string,
): { spaceKey: string; title: string; hasExplicitSpace: boolean } => {
	const delimiterPos = rootPageString.indexOf(':');
	if (delimiterPos > -1) {
		const rawSpaceKey = rootPageString.substring(0, delimiterPos);
		const spaceKey = rawSpaceKey || defaultSpaceKey;
		const title = rootPageString.substring(delimiterPos + 1);
		return { spaceKey, title, hasExplicitSpace: Boolean(rawSpaceKey) };
	}
	return { spaceKey: defaultSpaceKey, title: rootPageString, hasExplicitSpace: false };
};
